export const CREATE_AGREEMENT_START = 'CREATE_AGREEMENT_START';
export const CREATE_AGREEMENT_SUCCESS = 'CREATE_AGREEMENT_SUCCESS';
export const CREATE_AGREEMENT_ERROR = 'CREATE_AGREEMENT_ERROR';
export const ACCEPT_AGREEMENT_START = 'ACCEPT_AGREEMENT_START';
export const ACCEPT_AGREEMENT_SUCCESS = 'ACCEPT_AGREEMENT_SUCCESS';
export const ACCEPT_AGREEMENT_ERROR = 'ACCEPT_AGREEMENT_ERROR';
export const NEW_AGREEMENT_DATA_RECEIVED = 'NEW_AGREEMENT_DATA_RECEIVED';



// WEBPACK FOOTER //
// ./safeTrade/buyer/agreement/agreementActionTypes.js